import type { ComponentProps } from 'react'
import { GitPullRequestArrow, MessageSquareText } from 'lucide-react'
import type { WebModule } from '../core/index.js'
import { FeedbackPage } from './admin/FeedbackPage.js'
import { ChangesPage } from './admin/changes/ChangesPage.js'
import { CHANGES_PATH } from './admin/changes/changeText.js'
import { FEEDBACK_HELP_TOPICS } from './help.js'

/** What the feedback module contributes to the shells: the admin's feedback page, wearing how much arrived since the previous sign-in until it is opened, and the changes feedback becomes. */
export const feedbackWebModule: WebModule<ComponentProps<typeof FeedbackPage>['api']> = {
  name: 'feedback',
  adminPages: [
    {
      path: '/admin/feedback',
      label: 'Feedback',
      title: 'Product Feedback',
      icon: MessageSquareText,
      group: 'product',
      page: ({ api, session }) => <FeedbackPage api={api} session={session} newSince={session.previousLoginAt} />,
      badge: (session) => session.unseenFeedback,
      // Opening the page is what counts as having seen the new items.
      onShown: ({ session, onFeedbackSeen }) => {
        if (session.unseenFeedback > 0) {
          onFeedbackSeen()
        }
      },
    },
    {
      path: CHANGES_PATH,
      label: 'Changes',
      title: 'Changes',
      icon: GitPullRequestArrow,
      group: 'product',
      page: ({ api, session }) => <ChangesPage api={api} session={session} />,
    },
  ],
  helpTopics: FEEDBACK_HELP_TOPICS,
}
